__turbopack_context__.v({
  "className": "instrument_serif_e8e8c78e-module__ZTPZAq__className",
  "variable": "instrument_serif_e8e8c78e-module__ZTPZAq__variable",
});
